module.exports = __webpack_public_path__ + "static/img/my.e6739f40.svg";